export default "__VITE_ASSET__2unQmyOm__"